import { Controller } from '@hotwired/stimulus';

// Controller for toggling off-studio address fields visibility
// Used in booking process step 1 (shooting selection)
export default class extends Controller {
  static targets = ['checkbox', 'addressFields', 'studioSearch'];

  connect() {
    this.updateVisibility();
  }

  toggle() {
    this.updateVisibility();
  }

  updateVisibility() {
    const isOffStudio = this.checkboxTarget.checked;

    if (this.hasAddressFieldsTarget) {
      this.addressFieldsTarget.classList.toggle('hidden', !isOffStudio);
    }

    if (this.hasStudioSearchTarget) {
      // Disable studio search when off-studio is selected
      const studioSelect = this.studioSearchTarget.querySelector('select');
      if (studioSelect) {
        studioSelect.disabled = isOffStudio;
        if (isOffStudio) {
          studioSelect.value = '';
        }
      }
    }
  }
}
